/* One-time editorial motion. No hidden-content dependency or layout changes. */
(() => {
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 if(motion.matches||!('IntersectionObserver' in window)||!Element.prototype.animate)return;
 const active=new Map();
 const exclude='form,details,#product,.pdp-gallery,.pdp-info,.fit-guide,.range-measures,.home-print-loop,.shop-carousel,.shop-loop-track,.home-loop-track,.logo-gallery,[aria-hidden="true"]';
 const groups='.life-grid figure,.brand-example,.licence-card,.range-card,.original-card,.visual-benefit,.print-grid .print-card';
 const candidates=[...document.querySelectorAll(groups+',main h1,main h2,main h3,main p,main .howto-art,main .fold-grid > img,main .social-section > img,main .editorial-grid > img')];
 const targets=candidates.filter(el=>!el.closest(exclude)&&!el.parentElement.closest(groups));
 function finish(el){active.get(el)?.cancel();active.delete(el)}
 const observer=new IntersectionObserver(entries=>{
  let order=0;
  entries.forEach(entry=>{
   if(!entry.isIntersecting)return;
   const el=entry.target;observer.unobserve(el);
   if(motion.matches||el.contains(document.activeElement))return;
   const animation=el.animate([{opacity:.15,translate:'0 12px'},{opacity:1,translate:'0 0'}],{duration:480,delay:Math.min(order++*45,135),easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
   active.set(el,animation);animation.finished.then(()=>finish(el),()=>active.delete(el));
  });
 },{threshold:0,rootMargin:'0px 0px -16px 0px'});
 targets.forEach(el=>{const box=el.getBoundingClientRect();if(box.top>=innerHeight)observer.observe(el)});
 document.addEventListener('focusin',e=>{active.forEach((_,el)=>{if(el.contains(e.target))finish(el)})});
 motion.addEventListener('change',()=>{if(motion.matches){observer.disconnect();active.forEach((_,el)=>finish(el))}});
 window.addEventListener('pagehide',()=>{observer.disconnect();active.forEach((_,el)=>finish(el))},{once:true});
})();
